import { ADMIN, CONTROL } from '@rootCommon/constants/common';
import { FHQ_TEMPLATE, SITE_FHQ } from '@rootCommon/constants/end-points';
import CrudRequest from '@rootCommon/services/crud-request';
import { IdType } from '@rootTypes/common';
import { SiteFhq, SiteFhqDto } from '@rootTypes/fhq';
import { InviteTemplate, InviteTemplatesRequest } from '@rootTypes/fhq-invite-template';

class SiteFhqService {
  private getAllSiteFhqs = async (siteId: IdType, sender: string): Promise<SiteFhq[]> => {
    const res = await CrudRequest.get<SiteFhq[]>(`${SITE_FHQ}/all/${sender}`, { params: { siteId } });

    return res.data;
  };

  private updateSiteFhq = async (id: IdType, data: SiteFhqDto, sender: string): Promise<SiteFhq> => {
    const res = await CrudRequest.put<SiteFhq, SiteFhqDto>(`${SITE_FHQ}/${sender}`, data, { params: { id } });

    return res.data;
  };

  getAdminSiteFhqs = (siteFhqId: IdType) => this.getAllSiteFhqs(siteFhqId, ADMIN);

  getControlSiteFhqs = (siteFhqId: IdType) => this.getAllSiteFhqs(siteFhqId, CONTROL);

  getPatientInviteTemplates = async (params: InviteTemplatesRequest): Promise<InviteTemplate[]> => {
    const res = await CrudRequest.get<InviteTemplate[]>(`${FHQ_TEMPLATE}/all/invitation`, { params });

    return res.data;
  };

  updateAdminSiteFhq = (id: IdType, data: SiteFhqDto) => this.updateSiteFhq(id, data, ADMIN);

  updateControlSiteFhq = (id: IdType, data: SiteFhqDto) => this.updateSiteFhq(id, data, CONTROL);
}

export default new SiteFhqService();
